// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CiTwoToneSvg from "@fishx/icons-svg/es/asn/CiTwoTone";
import FishxIcon from '../components/FishxIcon';

var CiTwoTone = function CiTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CiTwoToneSvg
  }));
};

CiTwoTone.displayName = 'CiTwoTone';
export default React.forwardRef(CiTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CiTwoTone.js
// module id = 2220
// module chunks = 0